/**
 * bh-size-upsell.js — "Двойно повече торта само за +8 € [Избери Макси]" nudge
 * under the size picker. Copy: quantity framing ("double the roses for $X more") when the bigger
 * size at least doubles the pieces, otherwise "N парчета повече само за +X €"; action-verb button.
 *
 * Offers ONE next size up, only for the pairs in PAIRS: Bento → Maxi and XL → XXL. Maxi → L is
 * left out on purpose: L crosses into the Large add-on tier (€3 → €5 per add-on), so the real
 * jump is bigger than the price difference shown.
 *
 * Shown at the moment a size is picked (before sponge/fillings/date), so accepting is just a size
 * change: it calls window.bhApp.selectSize(), which already re-runs lead time, variant and message
 * limit. Listens for `bh:size-change` from bakehunters-configurator.js (selectSize/renderSizes).
 * Prices, pieces and names come from window.BakehuntersConfig.sizes (cake_size metaobjects).
 */
(function () {
  var box = document.getElementById('SizeUpsell');
  if (!box) return;

  var PAIRS = { bentoclassic: 'bentomaxi', bentoheart: 'heartmaxi', circlexl: 'circlexxl', heartxl: 'heartxxl' };
  var cfg = window.BakehuntersConfig || {};
  var T = cfg.t || {};
  var SIZES = cfg.sizes || [];
  var current = null;

  // ---- pure helpers ----
  function price(s) { return parseFloat((s.basePrice && s.basePrice.amount) || s.basePrice || 0); }
  function piecesHi(s) { return parseInt(String(s.portions || '').split('-').pop(), 10) || 0; }
  function byHandle(h) {
    h = String(h || '').toLowerCase();
    return SIZES.find(function (s) { return String(s.handle).toLowerCase() === h; });
  }

  // The offer for the chosen size, or null. dateStr = chosen date (YYYY-MM-DD) or null.
  function offerFor(handle, dateStr, today) {
    var cur = byHandle(handle);
    var next = byHandle(PAIRS[String(handle || '').toLowerCase()]);
    if (!cur || !next) return null;
    // A date is already picked and the bigger size can't make it: selectSize() would silently
    // clear the customer's date, so don't offer it.
    if (dateStr) {
      var min = new Date(today);
      min.setHours(0, 0, 0, 0);
      min.setDate(min.getDate() + (parseInt(next.minLeadDays, 10) || 0));
      if (new Date(dateStr + 'T00:00:00') < min) return null;
    }
    var curHi = piecesHi(cur), nextHi = piecesHi(next);
    if (!curHi || nextHi <= curHi) return null;
    var diff = price(next) - price(cur);
    return {
      handle: next.handle,
      size: next,
      diff: diff % 1 ? diff.toFixed(2) : String(diff), // "+8 €", not "+8.00 €"
      extra: nextHi - curHi,
      double: nextHi >= 2 * curHi // top of the range: Bento 4 → Maxi 8
    };
  }

  function fill(tpl, o, name) {
    return String(tpl || '').replace('{diff}', o.diff).replace('{name}', name)
      .replace('{extra}', o.extra);
  }

  // ---- render ----
  function render(handle) {
    var app = window.bhApp;
    current = app ? offerFor(handle, app.state && app.state.date, new Date()) : null;
    if (!current) { box.innerHTML = ''; return; }
    // Sit directly under the selected size (CSS spans it across the grid row). renderSizes()
    // replaces the pills' innerHTML, which detaches the box; we keep the reference and re-insert.
    var pill = document.querySelector('#SizePills .bh-pill.active');
    if (pill) pill.after(box);
    var name = app.sizeLabel ? app.sizeLabel(current.size) : current.size.name;
    box.innerHTML =
      '<p class="bh-size-upsell__text"><strong>' +
      fill(current.double ? (T.size_upsell_double || 'Двойно повече торта само за +{diff} €')
                          : (T.size_upsell_more || '{extra} парчета повече само за +{diff} €'), current, name) +
      '</strong></p>' +
      '<button type="button" class="bh-size-upsell__btn">' + fill(T.size_upsell_cta || 'Избери {name}', current, name) + '</button>';
    // Replay the entrance animation on every new offer.
    box.classList.remove('is-in');
    void box.offsetWidth;
    box.classList.add('is-in');
    // Three taps, each on a visual beat (only after a real tap): the box appearing (0ms), then the
    // shake's left (310ms) and right (400ms) peaks. Shake = 0.45s starting at 0.22s, peaks at 20% /
    // 40% (bh-size-upsell.css); change both together. Each tap is short so iOS clicks once per tap.
    if (window.bhHaptic) window.bhHaptic([
      { duration: 20, intensity: 0.7 },
      { delay: 290, duration: 15, intensity: 1 },
      { delay: 75, duration: 15, intensity: 1 }
    ]);
  }

  document.addEventListener('bh:size-change', function (e) { render(e.detail && e.detail.handle); });

  box.addEventListener('click', function (e) {
    if (!e.target.closest('.bh-size-upsell__btn') || !window.bhApp) return;
    var app = window.bhApp;
    // Re-check: the date may have been picked since the offer appeared.
    var o = offerFor(app.state.sizeHandle, app.state.date, new Date());
    if (!o) { box.innerHTML = ''; return; }
    if (window.bhHaptic) window.bhHaptic('success');
    if (window.bhClarityEvent) window.bhClarityEvent('bh_size_upsell_accept'); // CRO-001, docs/experiments.md
    // Hidden order flag (configurator adds `_bh_upsell` if this size is still chosen at add to cart).
    app.state.upsell = { to: o.handle, label: app.state.sizeHandle + ' → ' + o.handle };
    app.selectSize(o.handle);
    // The button is gone after the switch; keep focus on the newly selected size.
    var pill = document.querySelector('#SizePills .bh-pill.active');
    if (pill) pill.focus();
  });

  // The configurator can pre-select a size (URL param) before this script registers.
  if (window.bhApp && window.bhApp.state) render(window.bhApp.state.sizeHandle);

  // ponytail: UI glue has no unit-test harness; one-shot self-check behind a flag (as bh-size-guide).
  if (window.BHSU_DEBUG) {
    var bento = SIZES.find(function (s) { return String(s.handle).toLowerCase() === 'bentoclassic'; });
    if (bento) {
      console.assert(offerFor('bentoclassic', null, new Date()).handle.toLowerCase() === 'bentomaxi', 'bento → maxi');
      console.assert(offerFor('bentomaxi', null, new Date()) === null, 'no maxi → L');
      console.assert(offerFor('circlexl', '2000-01-01', new Date()) === null, 'date too soon blocks XXL');
    }
  }
})();
